import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';
import './sanitize-overrides.css';
import App from './App';
import './index.css';

const container = document.getElementById('root');
if (container === null) {
    throw new Error('Root container #root was not found in the document.');
}

createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>
);
